import { ProductTokens } from '../types'
import { colors, TheNightlyPalette } from './colors'

export const thenightly: ProductTokens<TheNightlyPalette> = {
    colors,
}
